<template>
  <div class="valid-cards" v-if="isShow">
    <div class="cards-wrap">
      <div class="content-warp">
        <p class="title">Valid Cards</p>

        <p class="content" v-for="(item, index) in validCardsOption" :key="index">{{index + 1}}. {{item.label}}</p>

      </div>
      
      <div class="btn-wrap">
        <el-button @click="isShowFn" >Close</el-button>
      </div>
    </div>
  </div>
</template>

<script>
  import {idTypeOptions} from "@/locales/select-data"

  export default {
    name: "ValidCards",

    props: {
      isShow: {
        type: Boolean,
        default: false
      }

    },
    model: {
      prop: 'isShow',
      event: 'returnShowFn'
    },

    data() {
      return {
        validCardsOption: idTypeOptions
      }
    },

    methods: {
      isShowFn() {
        this.$emit('returnShowFn', !this.isShow);
      }
    }
  }
</script>

<style lang="scss" scoped>
  .valid-cards {
    position: fixed;
    top:0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.30);
    z-index: 1000;
    .cards-wrap {
      position: absolute;
      width: 1080px;
      height: 680px;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      padding: 25px 64px 25px;
      background: #FFFFFF;
      border-radius: 14px;

      .content-warp {
        padding: 0px 17px;
        /*overflow: auto;*/
        height: 540px;
        /*overflow-y:scroll;*/
        -webkit-overflow-scrolling:touch;
      }
      .title {
        font-family: Nunito-Bold;
        font-size: 24px;
        color: #2C405A;
        text-align: left;
      }

      .content {
        font-family: Nunito-Regular;
        font-size: 14px;
        color: #000000;
        letter-spacing: -0.09px;
        line-height: 18px;
        text-align: left;
        margin-top: 12px;
      }

      .btn-wrap {
        border-top: 1px solid #EAEEF3;
        text-align: right;
        padding-top: 40px;
      }
    }
  }
</style>